export const safeDelete = (obj: any, prop: string) => {
  if (obj && obj.hasOwnProperty(prop)) {
    delete obj[prop];
  }
};
